export enum ResourceTypeEnum {
  ARTICLE = 'article',
  VIDEO = 'video',
  AUDIO = 'audio',
}
